<template>
  <div class="cases container">
    <p v-scroll-reveal>
      Clients
    </p>
    <h2 v-scroll-reveal="{ delay: 100 }">{{ header }}</h2>
    <div class="case-blocks">
      <div class="case" v-scroll-reveal="{ delay: 200 }">
        <img
          src="static/images/clients/logos/dw.svg"
          alt="Logo Daniel Wellington"
        />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 300 }">
        <img src="static/images/clients/logos/hs.svg" alt="Logo Happy Socks" />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 400 }">
        <img src="static/images/clients/logos/hope.svg" alt="Logo Hope" />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 500 }">
        <img src="static/images/clients/logos/fwss.svg" alt="Logo FWSS" />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 0 }">
        <img src="static/images/clients/logos/whyred.svg" alt="Logo Whyred" />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 100 }">
        <img src="static/images/clients/logos/eton.svg" alt="Logo Eton" />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 200 }">
        <img
          src="static/images/clients/logos/superfront.svg"
          alt="Logo Superfront"
        />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 300 }">
        <img
          src="static/images/clients/logos/stutterheim.svg"
          alt="Logo Stutterheim"
        />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 0 }">
        <img src="static/images/clients/logos/nakd.svg" alt="Logo NA-KD" />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 100 }">
        <img src="static/images/clients/logos/asket.svg" alt="Logo Asket" />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 200 }">
        <img
          src="static/images/clients/logos/frankenstorm.svg"
          alt="Logo Frankenstorm"
        />
      </div>
      <div class="case" v-scroll-reveal="{ delay: 300 }">
        <img src="static/images/clients/logos/cords.svg" alt="Logo Cords" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Clients",
  props: {
    header: String
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";

.cases {
  h2 {
    @include headline-small;
    font-weight: 400;
    width: 50%;
    margin-bottom: 1.5em;
    color: inherit;
    padding-right: 3vw;
  }
  .case-blocks {
    display: flex;
    //border-top:1px solid rgba(white,0.1);
    flex-direction: row;
    flex-wrap: wrap;
    .case {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 25%;
      flex-shrink: 0;
      //border-bottom:1px solid rgba(white,0.1);
      //border-right:1px solid rgba(white,0.1);
      //cursor: pointer;
      height: 20vh;
      padding-right: 3vw;
      &:hover {
        img {
          //opacity:0.5;
        }
      }
      &:nth-child(4n + 4) {
        border-right: 0;
      }
      h3 {
        @include headline-small;
        display: none;
      }
      img {
        max-width: 30%;
        max-height: 30%;
        opacity: 1;
        transition: opacity 0.3s ease-in-out;
      }
      svg * {
        fill: white;
      }
    }
  }
}
@media (max-width: $tablet) {
  .cases {
    h2 {
      width: 100%;
    }
    .case-blocks {
      .case {
        width: calc(100% / 3);
        padding-right: 0;
        img {
          max-width: 30%;
          max-height: 30%;
        }
      }
    }
  }
}
@media (max-width: $mobile) {
  .cases {
    .case-blocks {
      .case {
        width: 50%;
        img {
          max-width: 50%;
          max-height: 50%;
        }
      }
    }
  }
}
</style>
